export const LETTERS_NUMBERS =
  /^(?![.,\s-])(?!.*[.,\s-]$)(?!.*\s[.,-])(?!.*(?:[.,-]{2,}|([.,\s-])\1))(?!.*([A-Za-z0-9À-ÖØ-öø-ÿ])\2\2)[A-Za-z0-9À-ÖØ-öø-ÿ.,\s-]+$/gi

export const EMAIL_CHECK =
  /^[a-zA-Z0-9]((\.|\+|-|_)?[a-zA-Z0-9]){1,}@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/
